var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 288,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#274d73",
    d: "M14 33a5.34 5.34 0 10-5.33-5.33A5.33 5.33 0 0014 33zm0-8.67a3.34 3.34 0 11-3.33 3.34A3.34 3.34 0 0114 24.33z",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#274d73",
    d: "M52 24a12 12 0 10-11-7.32l-15.13 7.93a14 14 0 10-.95 16.13L32.6 46a12 12 0 1014-5.49l3.76-16.68A11.11 11.11 0 0052 24zm-6-4a6.3 6.3 0 0112 0 9.92 9.92 0 01-12 0zm6-18a10 10 0 017.63 16.45 8.32 8.32 0 00-15.26 0A10 10 0 0152 2zM2 32a12 12 0 1121 8 9.67 9.67 0 00-18 0 11.94 11.94 0 01-3-8zm4.63 9.45a7.66 7.66 0 0114.74 0 11.93 11.93 0 01-14.74 0zM37 60a6.3 6.3 0 0112 0 9.92 9.92 0 01-12 0zm16-8a9.94 9.94 0 01-2.37 6.45 8.32 8.32 0 00-15.26 0A10 10 0 1153 52zm-8.36-11.87A11.11 11.11 0 0043 40a12 12 0 00-9.27 4.39l-7.68-5.3a13.86 13.86 0 00.76-12.71l15.08-7.94a12.12 12.12 0 006.51 5z",
    className: "color000 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#274d73",
    d: "M52 13a4.67 4.67 0 10-4.67-4.67A4.68 4.68 0 0052 13zm0-7.33a2.67 2.67 0 11-2.67 2.66A2.67 2.67 0 0152 5.67zM38.33 48.33A4.67 4.67 0 1043 43.67a4.68 4.68 0 00-4.67 4.66zm7.34 0A2.67 2.67 0 1143 45.67a2.68 2.68 0 012.67 2.66z",
    className: "color000 svgShape"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDao);
export default __webpack_public_path__ + "static/media/DAO.efad82068a6a549bcc94136bbd0f0df0.svg";
export { ForwardRef as ReactComponent };